import { frontendURL } from '../../../../helper/URLHelper';

const SettingsWrapper = () => import('../SettingsWrapper.vue');
const PromoCode = () => import('./PromoCode.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/promo_code'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'promo_code',
          component: PromoCode,
          meta: {
            permissions: ['administrator'],
          },
        },
      ],
    },
  ],
};
